import makeStyles from '@mui/styles/makeStyles';
import Popover from "@mui/material/Popover";
import React from "react";
import {useTranslation} from "react-i18next";
import {color, font, radius, shadow, type} from "common/tokens";
import CtaButton from "components/redesign/CtaButton";
import TimeLineFilter from "components/Filter/TimeLineFilter";
import TypeOfPostFilter from "components/Filter/TypeOfPostFilter";

const useStyles = makeStyles({
  paper: {
    borderRadius: radius.CARD,
    boxShadow: shadow.POPOVER,
  },
  panel: {
    width: 288,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    padding: 20,
    boxSizing: 'border-box',
  },
  title: {
    ...type.eyebrow,
    fontWeight: font.BOLD,
    letterSpacing: '1.43px',
    color: color.SECTION_TITLE,
    margin: 0,
  },
});

const FeedFilterPopover = ({open, anchorEl, onClose, setFeedFilter, filter, applyFeedFilter}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  const apply = () => {
    applyFeedFilter();
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      classes={{paper: classes.paper}}
      anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
      transformOrigin={{vertical: 'top', horizontal: 'right'}}
    >
      <div className={classes.panel}>
        <p className={classes.title}>{t('filters')}</p>
        <TypeOfPostFilter setFeedFilter={setFeedFilter} filterValue={filter.event}/>
        <TimeLineFilter setFeedFilter={setFeedFilter} filterValue={filter}/>
        <CtaButton label={t('apply')} size={'control'} fullWidth onClick={apply}/>
      </div>
    </Popover>
  );
};

export default FeedFilterPopover;
